const getEasterEggMessageImage = (message: string) => {
  if (!message) return undefined;
  const messageToCompare = message.toLowerCase();

  if (messageToCompare === "clembg") {
    return "https://image.mux.com/TjVOmapSXevJjwSMk6uMgzwQpxshNuIyKOkRMFivSEs/animated.gif";
  } else if (messageToCompare === "rombg") {
    return "https://image.mux.com/MBkV801nH9ya2iorNYjop6Trxo1uNskIJPOeiuG8quYw/animated.gif";
  } else if (messageToCompare === "raphbg") {
    return "https://image.mux.com/z3PUK1Vs5hYdIatTVi9VxdTgkuCAFFoyHa9D3DiwhmI/animated.gif?start=3";
  }

  return undefined;
};

export default getEasterEggMessageImage;
